<template>
  <div class="centerx popup">
    <vs-popup class="holamundo" icon-close="x" :title="this.title" :active.sync="active">
      <div id="cont" class="content"></div>
    </vs-popup>
  </div>
</template>

<script>
export default {
  data()  {
      return {
        active: false,
        title: "",
        content: "",
      }
  },
  methods: {

    renderDom() {
        var divP = document.getElementById("cont")
          divP.innerHTML = ""
          var div = document.createElement("div")
          div.id = "vuejs-render"
          divP.appendChild(div);
          var tmp = Vue.extend({
            template: this.content,
          });
          new tmp().$mount(div);
    },

    toggle(title, urlBody, params = null) {
      event.preventDefault() ;
      let dataPopup = this;
      if (params!=null) {
        urlBody=urlBody+"?"+params;
      }
      axios.get(urlBody)
      .then(function (response) {
          let tempElement = document.createElement('div');
          tempElement.innerHTML = response.data;
          dataPopup.content = tempElement.innerHTML;
          dataPopup.title = title;
          dataPopup.active = true;
          dataPopup.renderDom();
        });
    }
  }
}
</script>